import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-header',
  templateUrl: './about-header.component.html',
  styleUrls: ['./about-header.component.css']
})
export class AboutHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
